import React, { FC } from 'react';
import { IFooter1 } from './params';
import Styles from './styles';
import { footer, routing } from '../../../translates';

const Footer: FC<{ config: IFooter1; language: string }> = ({ config, language }) => {
  const todaysYear = new Date();

  return (
    <Styles $config={config}>
      <div className="footer">
        <div className="container">
          <div className="footer-wrapper">
            <div className="footer-copyright">
              © {todaysYear.getFullYear()}{' '}
              {footer[language].copyright.charAt(0).toUpperCase() + footer[language].copyright.slice(1)}
            </div>
            <div className="footer-navlinks">
              <a href={routing[language].terms + '/'}>{footer[language].regulations}</a>
              <a href={routing[language].cookies + '/'}>{footer[language].cookiePolicy}</a>
            </div>
          </div>
        </div>
      </div>
    </Styles>
  );
};

export default Footer;
